export default __webpack_public_path__ + "static/media/colored_tiger.47be18e8.jpg";